/* unplugin-vue-components disabled */import { render } from "./ClassificationComponent.vue?vue&type=template&id=7f2fa934&scoped=true"
import script from "./ClassificationComponent.vue?vue&type=script&lang=js"
export * from "./ClassificationComponent.vue?vue&type=script&lang=js"

import "./ClassificationComponent.vue?vue&type=style&index=0&id=7f2fa934&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2fa934"]])

export default __exports__